import { ChangeDetectorRef, Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ARService } from '../../ar.service';
import {DataARLedgerModel} from '../../../../models/accountsReceivable/data-ar-ledger.model';

@Component({
  standalone: false,
  selector: 'app-ar-discount',
  templateUrl: './ar-discount.component.html',
  styleUrls: ['./ar-discount.component.css']
})
export class ArDiscountComponent implements OnInit {

  modified: boolean = false;
  ledgerItem: DataARLedgerModel;
  isLoading: boolean = false;
  enumCoverageTypeAmount: string = '00000048-1000-0000-0000-000000000002';
  enumCoverageTypePCT: string = '00000048-1000-0000-0000-000000000001';

  constructor(
    public dialogRef: MatDialogRef<ArDiscountComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBar: MatSnackBar,
    private arService: ARService,
    private changeRef: ChangeDetectorRef,
  ) { }

  ngOnInit() {

    this.ledgerItem = this.data.ledgerItem;

    if (!this.ledgerItem.dataARTransactionItem.enumFeeDiscountCalcTypeId) {
      this.ledgerItem.dataARTransactionItem.enumFeeDiscountCalcTypeId = this.enumCoverageTypePCT;
    }


  }

  calcAdjustedPrice(ledgerItem) {

    if (this.ledgerItem.dataARTransactionItem.enumFeeDiscountCalcTypeId === this.enumCoverageTypePCT) {

      if (this.ledgerItem.dataARTransactionItem.DiscountPCT == null || typeof this.ledgerItem.dataARTransactionItem.DiscountPCT === 'undefined') {
        return ledgerItem.Amount;
      } else {
        return ledgerItem.Amount * ((this.ledgerItem.dataARTransactionItem.DiscountPCT) / 100);
      }

    }

    if (this.ledgerItem.dataARTransactionItem.enumFeeDiscountCalcTypeId === this.enumCoverageTypeAmount) {

      if (this.ledgerItem.dataARTransactionItem.DiscountAmount == null || typeof this.ledgerItem.dataARTransactionItem.DiscountAmount === 'undefined') {
        return ledgerItem.Amount;
      } else {
        return ledgerItem.Amount - this.ledgerItem.dataARTransactionItem.DiscountAmount;
      }

    }

  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  close() {
    this.dialogRef.close(this.modified);
  }

  async save() {

    this.modified = true;
    this.isLoading = true;

    try {
      await this.arService.saveTransactionItem(this.ledgerItem.dataARTransactionItem).toPromise();
      this.createMessage('Discount saved', 'Success');
    } catch (err) {
      console.log(err);
      this.createMessage('Error saving discount', 'Error');
    }

    this.isLoading = false;
    this.changeRef.detectChanges();
    this.close();
  }

}
